import styled from 'styled-components';
import { BasicSectionContainer } from '../../style';
import {
  bookingStepContainerStyles,
  bookingStepContentStyles,
  roomSelectionMobileStyles,
} from '../../bookingStepStyles';
import { sectionBackgroundStyles } from 'screens/sectionBackgroundStyles';
// import noRoomsPicture from 'assets/images/noRoomsAvailable.png';
import { styleSizes } from "constants/styleSizes";

export const SearchResultOptionsContentContainer = styled(BasicSectionContainer)`

  ${bookingStepContainerStyles}

  .background {
    ${sectionBackgroundStyles}
    @media only screen and (max-width: ${styleSizes.tabletBreakpoint}) {
      display: none;
    }
  }

  .content {
    ${bookingStepContentStyles}
    column-gap: 32px;
  }
  @media only screen and (min-width: ${styleSizes.mobileBreakpoint}) and (max-width: ${styleSizes.tabletBreakpoint}) {
    .content {
      column-gap: 16px;
    }
  }

  ${roomSelectionMobileStyles}
`;

// Moved to common css ../../styles
// export const RoomOptionsContainer = styled(BasicSectionContainer)`
//   flex-basis: 60%;
//   max-width: 800px;
//   min-width: 315px;
//   display: flex;
//   flex-direction: column;
//   justify-content: flex-start;
//   margin-top: 45px;
//   @media only screen and (max-width: 1100px) {
//     flex-basis: 50%;
//   }
//   .noRoomsTitle {
//     font-size: 33px;
//     color: ${colors.red};
//     margin: 20px 0 0 0;
//   }

//   .noRoomsPicture {
//     width: 100%;
//     height: 447px;
//     background-size: contain;
//     background-position: left top;
//     background-repeat: no-repeat;
//     background-image: url(${noRoomsPicture});
//     margin: 20px 0 50px 0;

//     @media only screen and (max-width: 767px) {
//       height: auto;
//       background-position: center;
//     }
//   }

//   .roomOptionsTitle {
//     font-size: 33px;
//     font-weight: 600;
//     margin-bottom: 20px;
//   }

//   .roomOptionsFooter {
//     font-size: 15px;
//     font-style: italic;
//     color: ${colors.textInputLabel};
//     margin: 0 0 50px 0;
//   }

//   .loading {
//     font-size: 33px;
//     font-weight: 600;
//     margin: 20px 0;
//   }

//   @media only screen and (max-width: 767px) {
//     width: 100%;
//     max-width: 100%;

//     .noRoomsTitle {
//       text-align: center;
//     }

//     .noRoomsDescription {
//       width: 100%;
//       text-align: center;
//     }

//     .noRoomsPicture {
//       width: 100%;
//       height: 300px;
//       margin: 0;
//     }

//   }
// `;

// Moved to common css ../../styles
// export const BookingSummaryContainer = styled.div`
//   flex-basis: 40%;
//   min-width: 400px;
//   margin: 103px 0 0 0;

//   .card {
//     padding: 32px;
//   }

//   .title {
//     font-size: 24px;
//     margin: 10px 0 32px 0;
//     font-weight: 600;
//   }

//   .booking {
//     font-size: 18px;
//     margin: 38px 0 24px 0;
//     font-weight: 600;
//   }

//   .note {
//     font-size: 16px;
//     line-height: 24px;
//     margin: 32px 0;
//     span {
//       color: ${colors.red};
//       font-weight: 600;
//     }
//     b {
//       font-weight: 600;
//     }
//   }
//   .guestOption, .roomOption {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin: 24px 0;
//     //padding: 5px 0;
//     border-bottom: 1px solid ${colors.checkOutTableTextColor};

//     .text {
//       .optionTitle {
//         font-size: 16px;
//         height: 28px;
//         line-height: 21px;
//         font-weight: 600;
//         color: ${colors.black};
//         margin-bottom: 7px;
//       }

//       .optionDescription {
//         font-size: 16px;
//         font-style: italic;
//         color: ${colors.grey};
//         margin-bottom: 8px;
//       }
//     }

//     .optionButtons {
//       display: flex;
//       justify-content: space-between;
//       align-items: center;
      
//       .quantity {
//         text-align: center;
//         width: 30px;
//         height: 30px;
//         line-height: 30px;
//         font-size: 16px;
//         font-weight: 600;
//       }
//     }


//     .disabled {
//       g, line {
//         stroke: ${colors.signInBorderColor};
//       }
//     }
//   }

//   .controls {
//     display: flex;
//     flex-direction: row;
//     justify-content: flex-end;
//   }

//   .breakdownTable {
//   padding-top: 10px;
//   font-size: 16px;
//   width: 100%;

//   td {
//     padding-bottom: 15px;
//   }

//   .line {
//     display: flex;
//     align-items: center;
//     justify-content: space-between;
//     white-space: nowrap;
//   }

//   .label {
//     padding-right: 10px;
//   }

//   .dots {
//     flex-grow: 1;
//     border-bottom: 1px dotted #aaa;
//     margin: 0 10px;
//     height: 1px;
//     transform: translateY(-1px);
//   }
//   .price {
//     text-align: right;
//     white-space: nowrap;
//   }

//   .total {
//     font-weight: bold;
//   }
// }


//   .total {
//     font-weight: 600;
//   }

//   .priceDetails {
//     display: flex;
//     justify-content: space-between;
//     align-items: center;
//     margin: 10px 0;
//     padding: 5px 0;
//     border-bottom: 1px solid ${colors.checkOutTableTextColor};

//     .text {
//       font-size: 14px;
//       font-weight: 600;
//     }

//     .price {
//       font-size: 18px;
//       font-weight: 600;
//     }
//   }

//   @media only screen and (max-width: 767px) {
//     /* width: 100%;
//     max-width: 100%;
//     margin: 0 0 50px 0;

//     .title {
//       text-align: center;
//     } */
    
//     display: none;
//   }
// `;